import noop from 'lodash/noop';
import React, { MouseEventHandler } from 'react';
import successImage from '../assets/images/success_icon.png';
import Button from './Button';
import Modal from './Modal';

type AlertModalProps = {
  title: string;
  description?: string;
  isOpen: boolean;
  onClose?: MouseEventHandler;
};

const AlertModal = ({
  title,
  description = '',
  onClose: handleCloseModal = noop,
  ...restProps
}: AlertModalProps) => (
  <Modal
    overlayClassName="justify-center items-end md:items-center"
    className={{
      base:
        'rounded-t-lg md:rounded-br-lg transition-transform translate-y-9/10 md:translate-y-none md:scale-40',
      afterOpen: 'translate-y-none md:scale-100',
      beforeClose: 'translate-y-full md:translate-y-none'
    }}
    contentStyle={{
      width: '100%',
      maxWidth: '450px'
    }}
    overlayStyle={{ zIndex: 500 }}
    {...restProps}
  >
    <div className="mb-8 pt-6 px-6 md:pt-8 md:px-8 w-full flex flex-col items-center">
      <img src={successImage} alt="Success" className="w-64 h-64" />
      <h3 className="text-center text-2xl md:text-3xl text-primary font-display font-bold">
        {title}
      </h3>
      {description && (
        <p className="text-center text-gray-600 mb-8 font-body whitespace-pre-wrap">
          {description}
        </p>
      )}
      <Button block variant="primary" onClick={handleCloseModal}>
        Done
      </Button>
    </div>
  </Modal>
);

export default AlertModal;
